export default "__VITE_ASSET__06f09168__"